import React, {useEffect, useState} from 'react';

import {useParams} from 'react-router-dom';
import {
    getSimpleHoursMinutesFromISOString,
} from '../../../utils/dateFunctions';
import {Area, AreaChart, CartesianGrid, Legend, ReferenceLine, Tooltip, XAxis, YAxis} from 'recharts';
import {
    arrayFunctionForTypeDateGraph,
} from '../../../utils/arrayFunction';


export default function TypeDate({authFetch}) {
    const {typeId, date} = useParams();
    const [origType, setOrigType] = useState('');
    const [origTypeDateReadings, setOrigTypeDateReadings] = useState([]);


    useEffect(() => {
        const fetchUserType = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/type/${typeId}`);
            const data = await response.json();
            setOrigType(data);
        };

        const fetchUserTypeDateReadings = async (token) => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/reading/type/${typeId}/date/${date}`);
            const data = await response.json();
            setOrigTypeDateReadings(data);
        };

        fetchUserType();
        fetchUserTypeDateReadings();
    }, [authFetch, date, typeId]);

    const readingArray = arrayFunctionForTypeDateGraph(origTypeDateReadings, origType);

    const regex = /-/g;
    const stringSlashDate = date.replace(regex, '/');

    // console.log(readingArray);

    return (
        <>
            <h2>{origType.name} on {stringSlashDate}</h2>

            <ul>
                <li>Delay: {origType.reductionDelay} mins</li>
                <li>Reduction per Hour: {origType.reductionPerHour} {origType.activeUnits}</li>
                <li>Halflife: {origType.reductionHalflife} mins</li>
                <li>Daily limit: {origType.limit} {origType.activeUnits}</li>
                {origTypeDateReadings.length > 0 && origTypeDateReadings.map((reading) => {
                    return reading._id !== undefined && (
                        <li key={reading._id}>
                            Reading: {getSimpleHoursMinutesFromISOString(reading.dateTime)}, {reading.activeAmount} {origType.activeUnits} {reading.note && (', ' + reading.note)}
                            &nbsp;
                            <a href={'/edit-reading/' + reading._id}>edit</a>
                        </li>
                    );
                })}
            </ul>

            <AreaChart width={600} height={300} data={readingArray}>
                <Area type="monotone" dataKey={origType.name} name={origType.name} stroke="#8884d8" fill="#8884d8"/>
                <CartesianGrid stroke="#ccc"/>
                <XAxis dataKey="time"/>
                <ReferenceLine y={origType.limit} label="Do not go over" stroke="red"/>
                <YAxis/>
                <Tooltip/>
                <Legend/>
            </AreaChart>

            <p><a href={'/type/' + typeId}>Back to {origType.name}</a></p>

        </>
    );
}